import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types';

const stringDataType: TableColumn['dataType'] = {
  type: 'string',
  formatter: (value) => (value as string) || '',
};

export const RepairLocationGridColumns: Array<TableColumn> = [
  { id: 'code', label: 'Repair Location Code', width: '20%', dataType: stringDataType },
  { id: 'name', label: 'Description', width: '60%', dataType: stringDataType },
  { id: 'actions', label: '', sortDisabled: true, width: '20%' },
];
